import { usePortalBackgroundImageUrl } from '@/ui/components/portal-preview/use-portal-branding'

export const VerticalBanner: React.FC = () => {
  // Via the hook rather than the stored settings, so an editor's unsaved image previews.
  const backgroundUrl = usePortalBackgroundImageUrl()

  return (
    <div
      data-testid="banner"
      className="max-w-[599px]:hidden bg-grey-2"
      style={{
        backgroundImage: `url(${backgroundUrl})`
      }}
    />
  )
}

export default VerticalBanner
